import Stat from '@klv/molecules/stat';
import { generateClassName, getColorVariantFromBackground } from '@klv/shared/utils/functions';

import * as s from './styles/stats.module.css';

import type { IStats } from './types';

const Stats = ({
  background = 'light', disclaimer = '', stats, headline = '', ...rest
}: IStats) => (
  <section
    className={
      generateClassName([
        s.stats,
        s[background],
        'defaultPaddingTop',
        'defaultPaddingBottom'
      ])
    }
    {...rest}
  >
    <div className={generateClassName([s.grid, 'grid'])}>
      {headline && (
        <h2
          className={
            generateClassName([
              s.statsHeadline,
              s[getColorVariantFromBackground(background)],
              "h3",
            ])}
          >
          {headline}
        </h2>
      )}
      {stats.map((stat) => (
        <Stat background={background} headline={stat.headline} subcopy={stat.subcopy} key={JSON.stringify(stat)} />
      ))}
    </div>
    {disclaimer && (
      <div className="grid">
        <div
          className={
            generateClassName([
              s.statsDisclaimer,
              s[getColorVariantFromBackground(background)],
              "disclaimer"
            ])}
          dangerouslySetInnerHTML={{ __html: disclaimer }}
        />
      </div>
    )}
  </section>
);

export default Stats;
